import { Typo3SectionSpotSanityReports } from '@/types'
import { Button, Container } from '@/ui/components'
import { Tabs } from 'radix-ui'
import { memo } from 'react'

interface Props {
  tabs: string[]
  items: Typo3SectionSpotSanityReports['content']['items']
  dictionary: {
    [key: string]: string
  }
}

const TabsTrigger = ({ tabs, dictionary, items }: Props) => {
  const tabIcon = (tab: string): string | undefined => {
    switch (tab) {
      case 'lifts':
        return 'mdi:gondola'
      case 'slopes':
        return 'material-symbols:downhill-skiing'
      case 'avalanche':
        return 'mdi:alert'
      case 'sledging':
        return 'mdi:sledding'
      case 'winterhike':
        return 'ph:person-simple-hike-fill'
      case 'snowshoe':
        return 'material-symbols:snowshoeing'
      case 'snowreport':
        return 'mdi:snowflake'
      case 'trails':
        return 'map:cross-country-skiing'
      case 'icerink':
        return 'material-symbols:ice-skating-outline'
    }
    return undefined
  }

  return (
    <Container className="mb-xs overflow-x-auto pr-0!">
      <Tabs.List className={'gap-2xs flex'} aria-label="Reports">
        {tabs &&
          tabs?.map((tab) => (
            <Tabs.Trigger
              key={'tab-' + tab.toString()}
              value={tab.toString()}
              onClick={() => {
                const url = new URL(window.location.href)
                url.searchParams.set('tab', tab.toString())
                window?.history?.replaceState({}, '', url)
              }}
              asChild
            >
              <Button
                variant="secondary"
                size="m"
                className="data-[state=active]:bg-primary-400 data-[state=active]:text-neutral-100"
                icon={tabIcon(tab)}
                iconPosition="left"
              >
                {dictionary?.[`fe.reports.tab.${tab}`] as string}
              </Button>
            </Tabs.Trigger>
          ))}
      </Tabs.List>
    </Container>
  )
}

export default memo(TabsTrigger)
